const onlyValues = (values: any[]) => (value: string) => values.indexOf(value) !== -1;

export default onlyValues;
